<template>
    <div v-if="errorMessages && errorMessages[''] && errorMessages[''].length > 0" class="error-summary mt-1 pb-2 pt-2 bd-callout bd-callout-danger">
        <ul class="validation-summary-errors mb-0">
            <li class="error-summary-list" v-for="error in errorMessages['']">
                <span v-html="error"></span>
            </li>
        </ul>
    </div>

</template>

<script>

    import '../../patientportal/styles/PortalComponents/callouts.scss';
    import './error.summary.scss';

    export default {
        name: 'errorSummary',
        props: ['error-messages']
    };
</script>